import axios from 'axios';
import {API_GENIAM} from '../config/constants';

export const stripeAddCard = async (token) => {
    const {data} = await axios.post(`${API_GENIAM}/v1/cart/payment/cards/new`, {
        "source": token
    })
    return data
}
